import { gql } from '@apollo/client';

export const DASHBOARD_OUTCOMES = gql`
  query DashboardOutcomes($input: FilterArgs) {
    dashboardServiceProviders: dashboardFunderServiceProviders(input: $input) {
      id
      name
      beneficiariesCount
      mathsPassRate
      sciencePassRate
      englishPassRate
      schoolCount
      teacherCount
      learnerCount
    }
  }
`;
